import { Action } from 'redux';
import { ApplicationState } from '..';

export interface ChangeMenuSizeAction extends Action {
    type: '@@config/CHANGE_MENU_STATE';
    payload: {
        drawerMenuFolded: boolean;
    };
}

export interface SetRouterBasePathAction extends Action {
    type: '@@config/CHANGE_ROUTER_BASE_PATH';
    payload: {
        routerBasePath: string;
    };
}

export interface SetIsStandaloneAction extends Action {
    type: '@@config/CHANGE_IS_STANDLONE';
    payload: {
        isStandalone: boolean;
    };
}
export interface SetRtlAction extends Action {
    type: '@@config/SET_RTL';
    payload: {
        isRtl: boolean;
    };
}

export interface ConfigState {
    drawerMenuFolded: boolean;
    bootedAsChild: boolean;
    routerBasePath?: string;
    isStandalone?: boolean;
    isRtl?: boolean;
}

export const getConfigStore = (store: ApplicationState): ConfigState => store.config;
